"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rfc4648_1 = __importDefault(require("./rfc4648"));
exports.default = rfc4648_1.default;
